import React from 'react'

const Configs = (): JSX.Element => <div>Configs</div>

export default Configs
